"use client";
import * as React from "react";
const SvgEvStationSharp = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 14 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "m13.38 3.76.01-.009L10.232.444l-.9.943 1.79 1.875c-.89.356-1.493 1.307-1.34 2.41.136.977.933 1.768 1.867 1.875a1.99 1.99 0 0 0 1.077-.178v7.298H11.03V8H8.485V0H0v16h8.485V9.333h1.273V16H14V5.333c0-.613-.238-1.173-.62-1.573Zm-1.5 2.462c-.467 0-.849-.4-.849-.889s.382-.889.849-.889c.466 0 .848.4.848.89 0 .488-.382.888-.848.888Zm-8.485 7.111v-4H1.697l3.394-6.666V7.11h1.697l-3.394 6.222Z" }));
export {
  SvgEvStationSharp as default
};
